import React from "react";
import Expander from "../../Expander";
import { getVarsoUrl } from "../../../common/helpers/helpers";
import { createTableHeader, createTableRows } from "../helpers";

const drugLabelAnnotationTableHeaders = [
  {
    title: "Drug",
    class: "tw-text-left",
    key: "1",
  },
  {
    title: "Title",
    class: "tw-text-left",
    key: "2",
  },
  {
    title: "PGX Level",
    class: "tw-text-center",
    url: "https://www.pharmgkb.org/page/drugLabelLegend",
    key: "3",
  },
  {
    title: "FDA Biomarker List",
    class: "tw-text-center",
    url: "https://www.fda.gov/drugs/science-and-research-drugs/table-pharmacogenomic-biomarkers-drug-labeling",
    key: "4",
  },
];

const getDrugLabelAnnotationsRow = (item) => {
  const rows = [];
  if (item.drug_label_annotations && item.drug_label_annotations.length > 0) {
    const drugLabelAnnotationsLength = item.drug_label_annotations.length;
    item.drug_label_annotations.forEach((i, j) => {
      const row = (
        <tr
          key={i.key}
          className="tw-border-t tw-border-solid tw-border-gray-200 tw-break-words"
        >
          {j === 0 && (
            <td
              className="tw-text-left tw-p-2.5"
              rowSpan={drugLabelAnnotationsLength}
            >
              {item.drugNameIdUrl ? (
                <a href={getVarsoUrl(item.drugNameIdUrl)} target="_blank">
                  {item.name || "-"}
                </a>
              ) : (
                item.name || "-"
              )}
            </td>
          )}
          <td className="tw-text-left tw-p-2.5">
            {i.drugLabelNameIdUrl ? (
              <a href={getVarsoUrl(i.drugLabelNameIdUrl)} target="_blank">
                {i.name || "-"}
              </a>
            ) : (
              i.name || "-"
            )}
          </td>
          <td className="tw-text-center tw-p-2.5">
            {i.testing_level ? i.testing_level : "-"}
          </td>
          <td className="tw-text-center tw-p-2.5">
            {i.biomarker_flag ? i.biomarker_flag : "-"}
          </td>
        </tr>
      );
      rows.push(row);
    });
  }
  return rows;
};

export const getDrugLabelAnnotationsTable = (items) => {
  if (Array.isArray(items) && items.length !== 0) {
    const tableHeader = createTableHeader(drugLabelAnnotationTableHeaders);
    const rows = createTableRows(items, getDrugLabelAnnotationsRow);
    const result = (
      <table className="tw-w-full tw-border-collapse tw-border-t tw-border-solid tw-border-gray-200 tw-break-words tw-font-saphetor">
        {tableHeader}
        <Expander showMore="10" columns="4" component="tbody">
          {rows}
        </Expander>
      </table>
    );
    return result;
  }
  return null;
};
